module.exports = {
      id: "prayer-header-usage",
      viewBox: "0 0 300 193",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#prayer-header",
      toString: function () {
        return this.url;
      }
    }